module.exports = __webpack_public_path__ + "static/HakupaallaLehdenJuttu.2f1c71d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HakupaallaLehdenJuttu.jpg
// module id = 810
// module chunks = 129563053867776